import { useEffect, useRef, useState } from 'react';

export const parseCardAmount = (text) => {
  const value = String(text).trim();
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(value)) return null;
  const [whole, fraction = ''] = value.replace(',', '.').split('.');
  const minor = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(minor) && minor > 0 && minor <= 100000000 ? minor : null;
};

export const cardMoney = (minor, scale = 2, currency = 'USD') => {
  if (minor === null || minor === undefined || !Number.isFinite(Number(minor))) return '—';
  const value = (Number(minor) / 10 ** scale).toFixed(2);
  return currency === 'USD' ? `$${value}` : `${value} ${currency}`;
};

export const operationAmount = (op) => op.type === 'fee' && op.feeMinor > 0 ? op.feeMinor : op.amountMinor;
export const operationDate = (date) => {
  if (!date) return '';
  const utc = /(?:Z|[+-]\d\d:\d\d)$/.test(date) ? date : `${String(date).replace(' ', 'T')}Z`;
  const parsed = new Date(utc);
  let locale;
  try {locale = localStorage.getItem('i18nextLng') || navigator.language;} catch {}
  return Number.isNaN(parsed.valueOf()) ? String(date) : parsed.toLocaleString(locale, {dateStyle:'short',timeStyle:'short'});
};

export function useCardQuote(api, cardId, operation, amountMinor, active) {
  const [state, setState] = useState({quote:null, loading:false, error:null});
  const [version, setVersion] = useState(0);
  const sequence = useRef(0);
  const refresh = () => setVersion(v => v + 1);
  useEffect(() => {
    const seq = ++sequence.current;
    if (!active || amountMinor === null || amountMinor <= 0) {
      setState({quote:null,loading:false,error:null});
      return undefined;
    }
    setState({quote:null,loading:true,error:null});
    let expiry;
    const timer = setTimeout(async () => {
      try {
        const res = await api.get(`/cards/${cardId}/quote`, {params:{operation,amountMinor}});
        if (sequence.current !== seq) return;
        const quote = res?.data;
        if (!quote?.quoteId || quote.amountMinor !== amountMinor || quote.operation !== operation || quote.cardId !== cardId) throw new Error('invalid_quote');
        setState({quote,loading:false,error:null});
        expiry = setTimeout(refresh, Math.max(250, quote.expiresAt*1000-Date.now()-1000));
      } catch (error) {
        if (sequence.current === seq) setState({quote:null,loading:false,error});
      }
    }, 300);
    return () => { ++sequence.current; clearTimeout(timer); clearTimeout(expiry); };
  }, [api,cardId,operation,amountMinor,active,version]);
  const quote = state.quote;
  return {...state,quote,ready:Boolean(active && quote && quote.cardId===cardId && quote.operation===operation && quote.amountMinor===amountMinor && quote.expiresAt*1000>Date.now()),refresh};
}

export function useCardRefresh(reload, history) {
  useEffect(() => {
    const refresh = () => { if (!document.hidden) {reload();history();} };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    const timer = setInterval(refresh,30000);
    return () => {window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);clearInterval(timer);};
  }, [reload,history]);
}
